/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOpensearch = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M21.293 9.344a.707.707 0 0 0-.707.707c0 5.818-4.717 10.535-10.535 10.535a.707.707 0 0 0 0 1.414C16.65 22 22 16.65 22 10.05a.707.707 0 0 0-.707-.706zm-4.268 4.531c.68-1.11 1.338-2.588 1.209-4.659-.268-4.289-4.153-7.542-7.821-7.19-1.436.138-2.91 1.309-2.78 3.405.057.912.503 1.45 1.228 1.863.69.393 1.576.642 2.58.925 1.214.341 2.622.725 3.704 1.522 1.296.956 2.183 2.063 1.88 4.134zm-13.8-7.5c-.68 1.11-1.338 2.588-1.209 4.659.268 4.289 4.153 7.542 7.821 7.19 1.436-.138 2.91-1.309 2.78-3.405-.057-.912-.503-1.45-1.228-1.863-.69-.393-1.576-.643-2.58-.925-1.214-.341-2.622-.725-3.704-1.522-1.296-.956-2.183-2.064-1.88-4.134z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgOpensearch as Opensearch };
